/**
 * Get Marketer Financial Report Use Case
 *
 * Business logic for fetching marketer financial report
 */

import {ReportsRepository} from '../repository/ReportsRepository';
import {MarketerFinancialReport, ReportFilters} from '../models/report.model';

export class GetMarketerFinancialReportUseCase {
  constructor (private reportsRepository: ReportsRepository) {}

  async execute (marketerId: number, filters?: ReportFilters): Promise<MarketerFinancialReport> {
    try {
      // Validate marketer ID
      if (!marketerId || marketerId <= 0) {
        throw new Error('Invalid marketer ID');
      }

      // Validate date filters if provided
      if (filters?.date_from && filters?.date_to) {
        const fromDate = new Date(filters.date_from);
        const toDate = new Date(filters.date_to);

        if (fromDate > toDate) {
          throw new Error('Start date cannot be after end date');
        }
      }

      return await this.reportsRepository.getMarketerFinancialReport(marketerId, filters);
    } catch (error) {
      throw new Error(`Failed to get marketer financial report: ${error instanceof Error ? error.message : 'Unknown error'}`);
    }
  }
}


